var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M14,8H2C1.448,8,1,8.448,1,9v14c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1V9C15,8.448,14.552,8,14,8z"}}),_c('path',{attrs:{"d":"M18,4H5v2h12v14h2V5C19,4.448,18.552,4,18,4z"}}),_c('path',{attrs:{"d":"M22,0H9v2h12v14h2V1C23,0.448,22.552,0,22,0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }